/**
 * 权限认证
 */
import store from '../store'
import fetch from '../utils/fetch'

// 获取 wx-jssdk 授权配置
const getJssdkConfig = url => {
  return fetch.post('/v1/auth/jssdk', {
    url
  })
}

// 获取 jwt token
const getAuthToken = code => {
  return fetch
    .post('/v1/auth/token', {
      code
    })
    .then(res => {
      // 存储用户信息
      const user = res.data || {}
      store.commit('user/setUser', user)
      // 设置登录状态
      store.commit('user/setLoginStatus', 1)

      return res
    })
}

export default {
  getJssdkConfig,
  getAuthToken
}
